import { MemberLayout } from '@layout';
import {
    ListMemberPage,
    AddMemberPage,
    DashboardMemberPage,
    DetailsMemberPage,
    SettingsMemberPage,
    ListApartmentPage,
    EditionMemberPage,
    AddApartmentPage,
    DetailsApartmentPage,
    AddApartmentBookingPage,
    TicketingListPage,
    TicketingAddPage,
    TicketingAddMultiPage,
    TicketingEditionPage,
    AllApartmentBookingPage,
    ListBookingPage,
    SubscriptionsPage,
    FinancialBenefitEditionPage,
    SocialBenefitEditionPage,
    EtiquetteEditionPage,
    ContributionEditionPage
} from '@pages';
import { RouteObject } from 'react-router-dom';
import { RedirectToLogin } from '../RedirectToLogin';
import { AdminProtectedRoute } from '../AdminProtectedRoute';

export const memberRoutes = (isLogged: boolean | null | undefined): RouteObject[] => {
    const routes = [
        {
            element: isLogged ? <MemberLayout /> : <RedirectToLogin />,
            path: '/members-management',

            children: [
                {
                    path: '',
                    element: <DashboardMemberPage />
                },
                {
                    path: 'members',
                    children: [
                        {
                            path: '',
                            element: <ListMemberPage />
                        },
                        {
                            path: 'edition',
                            element: (
                                <AdminProtectedRoute parentItem="member">
                                    <EditionMemberPage />
                                </AdminProtectedRoute>
                            )
                        },
                        {
                            path: 'add',
                            element: <AddMemberPage />
                        },
                        {
                            path: ':id/edit',
                            element: <AddMemberPage />
                        },
                        {
                            path: ':id/details',
                            element: <DetailsMemberPage />,
                            children: [
                                {
                                    path: ':tab'
                                }
                            ]
                        }
                    ]
                },
                {
                    path: 'bookings',
                    children: [
                        {
                            path: '',
                            element: <ListBookingPage />
                        }
                    ]
                },
                {
                    path: 'apartments',
                    children: [
                        {
                            path: '',
                            element: <ListApartmentPage />
                        },
                        {
                            path: 'edition',
                            element: <AllApartmentBookingPage />
                        },
                        {
                            path: 'add',
                            element: <AddApartmentPage />
                        },
                        {
                            path: ':id/edit',
                            element: <AddApartmentPage />
                        },
                        {
                            path: ':id/details',
                            element: <DetailsApartmentPage />,
                            children: [
                                {
                                    path: ':tab'
                                }
                            ]
                        },
                        {
                            path: ':id/bookings',
                            children: [
                                {
                                    path: 'add',
                                    element: <AddApartmentBookingPage />
                                },
                                {
                                    path: ':bookingId/edit',
                                    element: <AddApartmentBookingPage />
                                }
                            ]
                        }
                    ]
                },
                {
                    path: 'settings',
                    element: (
                        <AdminProtectedRoute parentItem="member">
                            <SettingsMemberPage />
                        </AdminProtectedRoute>
                    ),
                    children: [
                        {
                            path: ':tab'
                        }
                    ]
                },
                {
                    path: 'ticketings',
                    children: [
                        {
                            path: '',
                            element: <TicketingListPage />
                        },
                        {
                            path: 'add',
                            element: <TicketingAddPage />
                        },
                        {
                            path: 'add-multi',
                            element: <TicketingAddMultiPage />
                        },
                        {
                            path: 'edition',
                            element: <TicketingEditionPage />
                        },
                        {
                            path: ':id/edit',
                            element: <TicketingAddPage />
                        }
                    ]
                },
                {
                    path: 'financial-benefits',
                    children: [
                        {
                            path: 'edition',
                            element: <FinancialBenefitEditionPage />
                        },
                    ]
                },
                {
                    path: 'contributions',
                    children: [
                        {
                            path: 'edition',
                            element: <ContributionEditionPage />
                        },
                    ]
                },
                {
                    path: 'social-benefits',
                    children: [
                        {
                            path: 'edition',
                            element: <SocialBenefitEditionPage />
                        },
                    ]
                },
                {
                    path: 'etiquettes',
                    children: [
                        {
                            path: 'edition',
                            element: <EtiquetteEditionPage />
                        },
                    ]
                },
                {
                    path: 'subscriptions',
                    children: [
                        {
                            path: '',
                            element: <SubscriptionsPage />
                        }
                    ]
                }
            ]
        }
    ];

    return routes;
};
